import type { AnyRouter } from "@tanstack/react-router";
import { scrubUrl } from "@/shared/lib/analytics";

// GA4's own history tracking never sees the router's navigations, so page views
// are sent from the router instead, once per path change including the first load.
export const initializeGoogleAnalytics = (
  measurementId: string,
  router: AnyRouter,
) => {
  window.dataLayer = window.dataLayer ?? [];
  // gtag.js only reads Arguments objects from the dataLayer, not arrays.
  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  const gtag = function (..._args: unknown[]) {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  gtag("js", new Date());
  gtag("config", measurementId, { send_page_view: false });

  router.subscribe("onResolved", ({ pathChanged }) => {
    if (!pathChanged) return;
    // "set" also covers GA's automatic events (scrolls, clicks) on this page.
    // The referrer is scrubbed too: after a full page load from an invite link
    // it is that link, email address and code included.
    gtag("set", {
      page_location: scrubUrl(window.location.href),
      page_referrer: scrubUrl(document.referrer),
      page_title: document.title,
    });
    gtag("event", "page_view");
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
};
